import { useRef } from 'react';

import { Flex } from '@chakra-ui/react';
import { useOKRRealignViewData } from 'components/RabbitOKRSidePanel/datahooks/useOKRRealignViewData';
import { useToast } from 'components/hooks/useToast';
import { useSelector } from 'react-redux';
import { kRDrawerSecondaryPanelSelector } from 'selectors/krSecondaryPanel';

import { ParentOKRSelectionGrid } from './ParentOKRSelectionGrid';
import { ParentOKRSelectionHeader } from './ParentOKRSelectionHeader';

/* Currently this section is handling both OKR alignment and OKR's children realignment */
export const ParentOKRSelectionV2 = ({
  localSelectedTimePeriod,
  setLocalSelectedTimePeriod,
  selectedParent,
  setSelectedParent,
}) => {
  const { details } = useSelector(kRDrawerSecondaryPanelSelector);
  const toast = useToast();

  const { okrTimePeriod, okrUuid, okrType, objectiveLevel, parentUuid, parentText, parentType, parentVisibilityType } =
    details;

  //   const [localSelectedTimePeriod, setLocalSelectedTimePeriod] = useLocalState(okrTimePeriod);

  //   const parentPost = useMemo(
  //     () => ({
  //       uuid: parentUuid
  //         ? String(parentUuid)
  //         : null /* At some place we are reading uuid as number and that causes issues in comparison */,
  //       text: parentText,
  //       type: parentType,
  //       visibilityType: parentVisibilityType,
  //     }),
  //     [parentUuid, parentText, parentType, parentVisibilityType]
  //   );

  //   const [selectedParent, setSelectedParent] = useLocalState(parentPost);

  const gridRef = useRef();

  const { data, isLoading } = useOKRRealignViewData({
    timeBoundPeriod: localSelectedTimePeriod,
  });

  return (
    <Flex flexDirection="column" height="100%" flex={1}>
      <ParentOKRSelectionHeader
        gridRef={gridRef}
        // @ts-ignore
        localSelectedTimePeriod={localSelectedTimePeriod}
        setLocalSelectedTimePeriod={setLocalSelectedTimePeriod}
      />

      <ParentOKRSelectionGrid
        selectedParent={selectedParent}
        setSelectedParent={setSelectedParent}
        gridRef={gridRef}
        gridData={data}
      />
    </Flex>
  );
};
